import { Selectable } from '@hakimo-ui/shared/ui-base';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSourceSystems(tenantId: string) {
  const url = `/v2/orm/tenant/sourceSystems?tenant_id=${tenantId}`;
  const request = new Request(url);

  return useAuthenticatedRequest<Selectable[]>(request, {
    queryKey: ['sourceSystems', tenantId],
    enabled: Boolean(tenantId),
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload.map((item: string) => ({ id: item, name: item }));
    },
  });
}

export default useSourceSystems;
